import { useEffect, useState } from 'react';
// contexts
import { useDrugManufacturersContext, useFooterContext, useProductsContext } from 'context';
// utils && hooks
import useCurrencyFormatter from 'utils/hooks/useCurrencyFormatter/useCurrencyFormatter';
import { useUser } from 'utils/hooks';
import { getEstimatedSavings } from '../../../utils/getEstimatedSavings';

export const useCanSaving = () => {
    const { footerValues, youAreSavings } = useFooterContext();
    const { products } = useProductsContext();
    const { drugManufacturer } = useDrugManufacturersContext();
    const { user, userLocaleCountryCode } = useUser({});
    const EX4562 = user?.EX4562;
    const [init, setInit] = useState<boolean>(true);
    const [displayValue, setDisplayValue] = useState<string>('0');

    const { formatCurrency } = useCurrencyFormatter();
    const { fullValue: footerValuesCanSaving } = formatCurrency({
        value: footerValues?.can_still_save || 0,
        digitsValidation: 7,
    });

    const { fullValue: estimatedSavingsCanSaving } = formatCurrency({
        value: getEstimatedSavings('youCanSave', products, drugManufacturer, userLocaleCountryCode, EX4562) || 0,
        digitsValidation: 7,
    });

    useEffect(() => {
        if (init) {
            setDisplayValue(footerValuesCanSaving);
            setTimeout(() => {
                setInit(false);
            }, 1500);
        } else {
            setDisplayValue(estimatedSavingsCanSaving);
        }
    }, [getEstimatedSavings('youCanSave', products, drugManufacturer, userLocaleCountryCode, EX4562)]);

    return {
        displayValue,
        footerValuesCanSaving: footerValues?.are_saving,
        estimatedSavingsCanSaving: getEstimatedSavings(
            'youCanSave',
            products,
            drugManufacturer,
            userLocaleCountryCode,
            EX4562,
        ),
        youAreSavings,
    };
};
